(ns common.schema.entities.rotation-period-override.schema
  (:require
   [common.schema.entities.rotation-period-override.options :as options]
   [common.schema.entities.rotation-period.option-source :as rotation-period-options]
   [common.schema.schema-utils :as su]))

(def schema
  "Editable rather than :in-use-disabled: the survey profile editor now
   creates and edits these through the shared entity editor, and a disabled
   field cannot be filled in. Visibility is schema metadata, not a Datomic
   datom, so this needs no migration."
  (vec
   (concat
    (su/single-ref-field :rotation-period-override/rotation-period
                         "Rotation period"
                         [:entity.type/rotation-period]
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use
                          ;; See the note on :survey-cycle/rotation-period -
                          ;; the default select is already search-backed for refs.
                          :option-filter-fn         rotation-period-options/for-profile-survey-type
                          :os-filter-terms-fn       rotation-period-options/profile-survey-type-filter-terms})
    (su/keyword-field :rotation-period-override/override-type
                      "Override type"
                      options/override-type-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})
    (su/single-ref-field :rotation-period-override/template
                         "Template"
                         [:entity.type/survey-template]
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use
                          ;; Scoped like the rotation period above. Not
                          ;; mandatory: an override of type Skip has no
                          ;; template, and only a Template override needs one.
                          :option-filter-fn
                          rotation-period-options/template-for-profile-survey-type
                          :os-filter-terms-fn
                          rotation-period-options/override-template-filter-terms}))))
